const MENU_CONFIG = [
  {
    label: 'InÃ­cio',
    icon: 'fa-home',
    method: 'goToDashboard',
    activeWhere: '/dashboard/',
    rules: ['company']
  },
  {
    label: 'Status das propostas',
    icon: 'fa-line-chart',
    method: 'goToConsolidatedOfBids',
    activeWhere: '/dashboard/consolidado',
    rules: ['company']
  },
  {
    label: 'OperaÃ§Ãµes',
    icon: 'fa-dollar',
    method: 'goToCreditOperationList',
    rules: ['consultant', 'company'],
    hideInURI: [/\/split-test/]
  },
  {
    label: 'Veja aqui sua CND',
    icon: ['fas', 'file-certificate'],
    method: 'goToCNDList',
    activeWhere: '/dashboard/cnd',
    rules: ['company'],
    badge: 'NOVO',
    useFaIconComponent: true
  },
  { label: 'OperaÃ§Ãµes', icon: 'fa-dollar', method: 'goToOperations', rules: ['operator'] },
  { label: 'Empresas', icon: 'fa-building', method: 'goToCompaniesConsultant', rules: ['consultant'] },
  { label: 'Empresas', icon: 'fa-building', method: 'goToCompanies', rules: ['operator'] },
  { label: 'IndicaÃ§Ãµes', icon: 'fa-sitemap', method: 'goToIndications', rules: ['consultant'] },
  { label: 'PendÃªncias', icon: 'fa-exclamation-triangle', method: 'goToPendencies', rules: ['consultant'] },
  { label: 'Consultores', icon: 'fa-address-card', method: 'goToConsultants', rules: ['operator'] },
  { label: 'Financiadores', icon: 'fa-bank', method: 'goToInvestors', rules: ['operator'] },
  { label: 'Faturamento', icon: 'fa-bar-chart', method: 'goToPayment', rules: ['operator'] },

  // My account, always needs to be the last one on the list to handle the liability
  {
    label: 'Minha conta',
    icon: 'fa-user-circle',
    rules: ['consultant', 'company', 'operator', 'investor'],
    event: 'profile-box'
  },
];

const SUBMENU_CONFIG = [
  { label: 'AdministraÃ§Ã£o', method: 'goToConfig', rules: ['operator'] },
  { label: 'Dataroom', method: 'goToDataroom', rules: ['operator'] },
  { label: 'PendÃªncias', method: 'goToPendencies', rules: ['operator'] },
  { label: 'Editar contato', method: 'goToEditProfile', rules: ['consultant', 'company', 'investor'], hideInURI: [/\/split-test/] },
  { label: 'Alterar senha', method: 'openChangePassword', rules: ['consultant', 'company', 'investor', 'operator'] },
  { label: 'Sair', method: 'logout', rules: ['consultant', 'company', 'investor', 'operator'] }
];


export { MENU_CONFIG, SUBMENU_CONFIG };
